// extracted by css-extract-rspack-plugin
export default {"inventoryCount":"inventoryCount-ng7Q9_"};